import { render, staticRenderFns } from "./AdminBrandSearch.vue?vue&type=template&id=766fedff"
import script from "./AdminBrandSearch.vue?vue&type=script&lang=js"
export * from "./AdminBrandSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports